export default __webpack_public_path__ + "static/media/004-ice cream.b06353bc.svg";